import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_TRACKER } from 'base/config/constant';
import site from 'pro/config/site';
import { getCookie } from 'ava-util/dist/cookie';

declare const window: any;

export type IFbEventData = {
    content_category?: string; //页面/商品的类别。
    content_ids?: number | string[]; //与事件相关联的商品编号，例如 SKU（如 ['ABC123', 'XYZ789']）。
    content_name?: string; //页面/商品的名称。
    content_type?: 'product' | 'product_group'; //根据所传递的 content_ids 或 contents，可能为 product 或 product_group。如果在 content_ids 或 contents 参数中传递的编号是商品编号，则该值应为 product。如果所传递的是商品组编号，则该值应为 product_group。
    contents?: Object[]; //JSON 对象数组，包含数量和国际商品编码 (EAN)（如适用）或其他商品或内容标识符。id 和 quantity 为必要字段，例如 [{'id': 'ABC123', 'quantity': 2}, {'id': 'XYZ789', 'quantity': 2}]。
    currency?: string; //所指定 value 的货币。
    num_items?: number; //与 InitiateCheckout 事件结合使用。开始结账时的商品数量。
    predicted_ltv?: number; //所预测的订户终生价值，由广告主定义并以精确值的形式表示。
    search_string?: string; //与 Search 事件结合使用。用户搜索时输入的字符串。
    status?: boolean; //与 CompleteRegistration 事件结合使用，用于显示注册状态。
    value?: number; //向商家执行此事件的用户的值。
}


let isStarted = false; //是否开始发送数据
let todoFunctions: Function[] = []; //等待执行的回调

/**
 * 打点
 * @param eventType 事件类型（标准事件和自定义事件） https://developers.facebook.com/docs/meta-pixel/reference
 * @param eventName 事件名称
 * @param data 数据
 * @param eventID 订单号
 */
function track(eventType: 'track' | 'trackCustom' | 'init', eventName: string, data?: any, eventID?: string | number) {
    if (getParamInSearch(DEBUG_TRACKER) === '1') {
        console.log(`-----FB ${eventType}: ${eventName} -----`);
        if (eventID) {
            console.log(`eventID: ${eventID}`)
        }
        console.log(data);
    }
    if (window.fbq) {
        return window.fbq(eventType, eventName, data, { eventID } );
    }
}

/**
 * 运行 todoFunctions 中保存你的等待执行的回调函数
 */
function runCallbacks(): void {
    // 执行待执行的回调
    if (todoFunctions.length) {
        todoFunctions.map(callback => callback());
        todoFunctions = [];
    }
}

/**
 * 发送数据前验证是否符合发送条件，不符合条件的暂时保存在 todoFunctions 数组中
 * @param methodName snowplow api中的 method
 * @param data 要发送的数据
 */
function trackOrDelay(eventType: 'track' | 'trackCustom', eventName: string, data?: any, eventID?: string | number) {
    // sp.js 加载完成并且主动触发 start 之前，放到数组中等待执行
    if (isStarted) {
        track(eventType, eventName, data, eventID);
    } else {
        todoFunctions.push(function () {
            track(eventType, eventName, data, eventID);
        });
    }
}

export function getFbClientId() {
    return getCookie('_fbp') || '';
}

/**
 * 开始发出打点请求
 * https://developers.facebook.com/docs/meta-pixel/advanced/advanced-matching
 */
export function fbStartTrack(userId: string | 0, email: string) {
    if (userId === 0) {
        track('init', site.facebook.pixelId);
    } else {
        track('init', site.facebook.pixelId, {
            'external_id': userId,
            'em': email
        })
        ;
    }

    if (!isStarted) {
        isStarted = true;
        runCallbacks();
    }
}

export function fbPageView(eventID?: string) {
    trackOrDelay('track', 'PageView',{}, eventID);
}

export function fbEvent(eventName: string, data: IFbEventData, eventID?: string) {
    trackOrDelay('track', eventName, data, eventID);
}

export function fbCustomEvent(eventName: string, data: IFbEventData, eventID?: string) {
    trackOrDelay('trackCustom', eventName, data, eventID);
}
